//import { environment } from './../../environments/environment.prod';
import { environment } from './../../environments/environment';
import { LoginService } from 'app/login/login.service';
import { ConfigService } from './config.service';
import { IConfig } from './model/config.interface';
import { config } from 'rxjs';
import { Injectable } from '@angular/core';

export class AppSettings {
    

    

    //Admin    
    // public  addOved = this.apiUrl +'api/admin/AddOved';
    // public  getOved = this.apiUrl +'api/admin/GetOvedDeatils'; //GetOvedDeatils
    // public  getMobilePrefixes= this.apiUrl + 'api/admin/GetMobilePrefixes';
    // public  isOvedExists = this.apiUrl + 'api/admin/IsOvedExists';    
   
    // public  updateOvedDetails = this.apiUrl + 'api/admin/updateOvedDetails';
    // public  getIsAdmin = this.apiUrl + 'api/admin/getIsAdmin';
    // public  deleteOved = this.apiUrl + 'api/admin/deleteOved';
    // public  getOvedDetailsPeilut = this.apiUrl + 'api/admin/GetOvedDetailsPeilut';
    // public  addOvedPeilut = this.apiUrl + 'api/admin/addOvedPeilut';
    // public  isOvedExistsPeilut = this.apiUrl + 'api/admin/isOvedExistsPeilut';
    // public  updateOvedDetailsPeilut = this.apiUrl + 'api/admin/updateOvedDetailsPeilut';
    // public  deleteOvedPeilut = this.apiUrl + 'api/admin/deleteOvedPeilut';
    // public  getNofshonimCharigim = this.apiUrl + 'api/admin/getNofshonimCharigim'
    // public  deleteNofshonCharig = this.apiUrl + 'api/admin/deleteNofshonCharig';
    // public  GetOvedNofeshSingleReservation = this.apiUrl + 'api/admin/GetOvedNofeshSingleReservation';
    // public  nofeshUniteSingles = this.apiUrl + 'api/admin/nofeshUniteSingles';
    // public  GetNofeshAllNirshamimReservation = this.apiUrl + 'api/admin/GetNofeshAllNirshamimReservation';
    // public  changeReservation = this.apiUrl + 'api/admin/changeReservation';
    // public  GetNofshonimAllNirshamimReservation = this.apiUrl + 'api/admin/GetNofshonimAllNirshamimReservation';
    // public  changeReservationNofshon = this.apiUrl + 'api/admin/changeReservationNofshon';
    // public  getDetailsForNofshonTashlumim = this.apiUrl + 'api/admin/getDetailsForNofshonTashlumim';
    // public  getMeshalemEmzaiTashlum = this.apiUrl + 'api/admin/getMeshalemEmzaiTashlum';
    // public  updateNofshonMeshalmim = this.apiUrl + 'api/admin/updateNofshonMeshalmim';
    
    // //Peiluyot
    // public  endRishumUrl = this.apiUrl + 'api/endRishum';
    // public  logintUrl = this.apiUrl + 'token';
    // public  peilutUrl = this.apiUrl + 'api/Peilut';
    // public  userUrl = this.apiUrl + 'api/User';
    // public  benZugUrl = this.apiUrl + 'api/User/GetUserDetails';
    // public  reportUrl = this.apiUrl + 'api/Report';
    // public  peilutDdlUrl = this.apiUrl + 'api/Peilut/GetPeilutDdl';
    // public  tatPeilutDdlUrl = this.apiUrl + 'api/Peilut/GetTatPeilutDdl';

    // //Matanot
    // public  matanotUrl = this.apiUrl + 'api/Matana/GetMatanot';
    // public  matanotUserUrl = this.apiUrl + 'api/Matana/GetUserMatanot';
    // public  matanotSaveRishumUrl = this.apiUrl + 'api/Matana/SaveRishumMatana';
    // public  matanotEndRishumUrl = this.apiUrl + 'api/Matana/GetEndRishumMatana';
    // public  matanotEzorRishumUrl = this.apiUrl + 'api/Matana/GetMatanaEzorChaluka';
    // public  matanotDdlUrl = this.apiUrl + 'api/Matana/GetMatanotDdl';
    // public  chalukatMatanot = this.apiUrl + 'api/Matana/GetChlukatMatanot';
    // public  yechidotDdlUrl = this.apiUrl + 'api/Matana/GeYechidotDDL';
    // public  yechidotMishneDdlUrl = this.apiUrl + 'api/Matana/GeYechidotMishneDDL';
    // public  matanotChalukaApprovedUrl = this.apiUrl + 'api/Matana/SaveChalukaApproved';

    // //Keep In Touch
    // public  keepInTouchUserDetails = this.apiUrl + 'api/User/GetUserKeepInTouch';
    // public  keepInTouchSaveUserDetails = this.apiUrl + 'api/User/SaveUserKeepInTouch';

    // //Nofesh
    // public  getNofeshDdlDataUrl = this.apiUrl + 'api/Nofesh/GeNofeshTypeDDL';
    // public  addNofesh = this.apiUrl + 'api/Nofesh/AddNofesh';
    // public  getNofesh = this.apiUrl + 'api/Nofesh/getNofesh';
    // public  getCurrentNofesh = this.apiUrl + 'api/Nofesh/GetCurrentNofesh';
    // public  getAllNofashim = this.apiUrl + 'api/Nofesh/getAllNofashim';
    // public  getNofeshPrices = this.apiUrl + 'api/Nofesh/GetNofeshPrices';
    // public  getNofeshNirshamim = this.apiUrl + 'api/Nofesh/GetNofeshNirshamim';
    // public  saveNofeshNirshamim = this.apiUrl + 'api/Nofesh/SaveNofeshNirshamim';
    // public  getNofeshPayment = this.apiUrl + 'api/Nofesh/GetNofeshPayment';
    // public  saveNofeshTashlumim = this.apiUrl + 'api/Nofesh/SaveNofeshTashlumim';
    // public  saveNofeshCilabus = this.apiUrl + 'api/Nofesh/saveNofeshCilabus';
    // public  nofesh_syllabus_file_url = this.apiUrl + 'UploadFiles/NofeshSyllabus/';
    // public  getNofeshUploads = this.apiUrl + 'api/Nofesh/GetNofeshUploads';
    // public  saveNofeshUploads = this.apiUrl + 'api/Nofesh/SaveNofeshUploads';
    // public  getUserSelectedNofesh = this.apiUrl + 'api/Nofesh/GetUserSelectedNofesh';
    // public  saveNofeshCancelByUser = this.apiUrl + 'api/Nofesh/SaveNofeshCancelByUser';
    // public  saveNofeshEndRishum = this.apiUrl + 'api/Nofesh/SaveNofeshEndRishum';
    // public  nofeshAgreementsFileUrl = this.apiUrl + 'UploadFiles/NofeshAgreements/';
    // public  GetNirshamDetails = this.apiUrl + 'api/Nofesh/GetNirshamDetails';

    // //Nofshonim

    // public  SaveNofshonReservation = this.apiUrl + 'api/Nofesh/SaveNofshonReservation';
    // public  SaveNofshonNirshamim = this.apiUrl + 'api/Nofesh/SaveNofshonNirshamim';
    // public  GetNofshonNirshamim = this.apiUrl + 'api/Nofesh/GetNofshonNirshamim';
    // public  UpdateTashlumById = this.apiUrl + 'api/NofeshonChul/UpdateTashlumById';
    // public  SaveNofshonCancledByUser = this.apiUrl + 'api/Nofesh/SaveNofshonCancelByUser';
    // public  getNofshonPayment = this.apiUrl+ 'api/Nofesh/getNofshonPayment';
    // public  getNofshonQuotation = this.apiUrl + 'api/Nofesh/GetNofshonQuotation';
    // public  NofshonTashlumimUri = this.apiUrl + 'api/Nofesh/GetNofshonTashlumim';
    // public  getNofshonUploads = this.apiUrl + 'api/Nofesh/GetNofshonUploads';
    // public  saveNofshonUploads = this.apiUrl + 'api/Nofesh/SaveNofshonUploads';
    // public  saveNofshonTashlumim = this.apiUrl + 'api/Nofesh/SaveNofshonTashlumim';
    // public  sendNofshonimSms =  this.apiUrl + 'api/Nofesh/SendNofshonimSms'
    // // public static GetNofeshonNirshamimChul = this.apiUrl + 'api/NofeshonChul/GetNofeshNirshamimChul?nofeshId=';

    // // Mishpachot Chul
    // //public static mishpachotChulGetRoomQuotation = this.apiUrl + "api/MishpachotChul/GetRoomQuotation";

    public static prefixes = [
        { num: "050", name: "050" },
        { num: "052", name: "052" },
        { num: "053", name: "053" },
        { num: "054", name: "054" },
        { num: "055", name: "055" },
        { num: "058", name: "058" }
    ];

        public static dayLabels = { su: 'א', mo: 'ב', tu: 'ג', we: 'ד', th: 'ה', fr: 'ו', sa: 'ש' };
        public static monthLabels = { 1: 'ינו', 2: 'פבר', 3: 'מרץ', 4: 'אפר', 5: 'מאי', 6: 'יוני', 7: 'יולי', 8: 'אוג', 9: 'ספט', 10: 'אוק', 11: 'נוב', 12: 'דצמ' };
    
}